export const CSV_CONFIG = {
  maxFileSize: 10 * 1024, // 10KB
  acceptedFileTypes: { 'text/csv': ['.csv'] },
};

export const CSV_ERRORS = {
  generic: 'Something went wrong. Please review your file and try again.',
  noData: 'No data found. Please review your file and try again.',
  invalidColumns:
    'An email and name column is required. Please review your file and try again.',
  invalidFileType: 'Invalid file type. Please upload a CSV file.',
  tooManyFiles: 'Too many files. Please upload one file at a time.',
  duplicateEmails:
    'File includes duplicate emails. Please remove them and try again.',
  size: `File is too large. Maximum size is ${Math.round(
    CSV_CONFIG.maxFileSize / 1024,
  )}KB. Please upload a smaller file.`,
};

export const SAMPLE_DOWNLOAD_DATA = [
  { email: 'sarah.johnson@example.com', name: 'Sarah Johnson' },
  { email: 'michael.chen@example.com', name: 'Michael Chen' },
  { email: 'emily.rodriguez@example.com', name: 'Emily Rodriguez' },
];

//Server error messages
type ErrorMessages = Record<string, { SINGLE: string; MULTIPLE: string }>;
export const ADD_MEMBERS_ERROR_MESSAGES: ErrorMessages = {
  'lumiq.membership.authorization.duplicate_emails': {
    SINGLE: 'Account already exists',
    MULTIPLE: 'Some accounts already exist. Remove them and try again.',
  },
};

export const AddMemberErrorCodes = Object.keys(ADD_MEMBERS_ERROR_MESSAGES);
